let pre_v10 = "/api/cmss"; // https://zdzfknowledge.wxzhida.cn

let pre_v11 = "/api/d1";
let pre_v12 = "https://api-charge.shzhida.com"; // 正式环境 https://api-charge.shzhida.com

let api = {};

api.login = "/api/login";
api.knowledge = {
  // 桩列表
  custpile: pre_v11 + "/app/custpile/page",
  // 数据统计 统计 - 充电次数、时长、电量
  pileOrderAppStats: pre_v11 + "/app/stats/pileOrderAppStats",
  // 数据统计 折线 - 充电次数、时长、电量
  pileOrderAppCurve: pre_v11 + "/app/stats/pileOrderAppCurve",
  // 数据统计 环形图 - 充电次数、时长、电量
  peakValleyPre: pre_v11 + "/app/stats/peakValleyPre",

  // 充电安全
  areaDataList: pre_v11 + "/app/pileorder/areaDataList",

  // 发现页面 banner
  bannerList: pre_v11 + "/app/banner/findAll",

  // 发现页面
  /** 验签 */
  check: pre_v10 + "/check/check",
  /** serviceCenter*/
  bannerFindAll: pre_v10 + "/banner/findall", //banner
  pileProductFindall: pre_v10 + "/pileProduct/getList", //充电桩相关-型号下拉  1
  commonProblemsFindall: pre_v10 + "/commonProblems/findall", //常见问题tag
  relatedDocFindall: pre_v10 + "/relatedDoc/findall", //相关文档tag
  findKnowledge: pre_v10 + "/knowledge/findKnowledge", //常见问题列表
  findMaterial: pre_v10 + "/material/findMaterial", //相关文档
  /** 型号页面*/
  pileProduct: pre_v10 + "/pileProduct", //
  knowledge: pre_v10 + "/knowledge", //列表、id查询、删除接口
  detail:pre_v11 + "/aliMiniPro/custpile/defaultPileInfo", // 桩详情
  getActivityOrder:pre_v11 + '/aliMiniPro/zeroPay/getActivityOrder'
};

/**重构充电安全和数据统计 */
api.reconsitution = {
  listMyChargePoint:
    pre_v12 + "/manage-service/charge-point-relative/listMasterChargePoint", // 查询全部桩
  chargeSafeStats: pre_v12 + "/manage-service/app/chargeSafeStats",
  chartData: pre_v12 + "/manage-service/dataStatistics/chartData",
  cumulativeData: pre_v12 + "/manage-service/dataStatistics/cumulativeData",
};

/**挚复相关接口 */
api.fudan = {
  agree: pre_v12 + "/knowledge-service/zeeda_knowledge/content/agree", // 勾选协议
  isAgree: pre_v12 + "/knowledge-service/zeeda_knowledge/content/isAgree", // 挚复查询用户是否同意了协议
  isFind:pre_v12 + "/knowledge-service/zeeda_knowledge/content/isFind", // 挚复发现进入埋点
};
export default api;
